/* eslint-disable @typescript-eslint/no-unused-vars */

import { useGetCopilotPreview } from '../../../hooks/useGetCopilotPreview';
import { PENDING } from '../../../types/requestStatus';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CopilotPreviewAutoGeneratedV2 = props => {
  const {
    actionButtonRef,
    aiTracker,
    copilotAction,
    previewKey,
    previewSource,
    previewTitle,
    numHoursTilSummaryStale,
    numHoursTilSummaryStaleRefresh,
    onChatWithCopilot,
    onPositiveFeedback,
    onNegativeFeedback,
    onRefresh,
    onPreviewShown,
    onQuickActionClick,
    usageTrackerAppLocationKey,
    overrideDisabled,
    onDontShowAgain,
    isExpandable,
    defaultExpanded,
    maxHeight
  } = props;
  const {
    preview,
    requestStatus,
    error
  } = useGetCopilotPreview(previewKey, previewSource, copilotAction);
  if (requestStatus === PENDING) {
    return /*#__PURE__*/_jsx("div", {
      children: "Loading..."
    });
  }
  if (error) {
    return /*#__PURE__*/_jsxs("div", {
      children: ["Error: ", error.message]
    });
  }
  return /*#__PURE__*/_jsx("div", {
    children: "CopilotPreviewAutoGeneratedV2"
  });
};